import type { ProductColor } from '@aloft/toolkit-shared';
import { Block, Flex, Typography } from '@aloft/toolkit-sui';

import { DetailLine } from './DetailLine.tsx';

type DetailLineWithValueProps = {
  text?: string;
  value?: string;
  textColor?: ProductColor;
  valueColor?: ProductColor;
  topBorder?: boolean;
};
export const DetailLineWithValue = ({
  text = '',
  value = '',
  textColor,
  valueColor,
  topBorder = false,
}: DetailLineWithValueProps) => (
  <Flex
    justifyContent="space-between"
    gap=".25rem"
    flexWrap="nowrap"
    borderStyle="solid"
    borderColor="strokeLight"
    borderTopWidth={topBorder ? '1px' : 0}
  >
    <Block minWidth="0" maxWidth="70%" flexBasis="60%">
      <DetailLine text={text} noPadding color={textColor} />
    </Block>
    <Block textAlign="right">
      <Typography color={valueColor ?? 'textPrimary'}>{value ?? ''}</Typography>
    </Block>
  </Flex>
);
